import { DEFAULT_LISTINGS_SORTING } from '@lib/components'

import { PublishedListingsState } from './types'

export const initialState: PublishedListingsState = {
  listings: [],
  fetching: false,
  loaded: false,
  hasMore: true,
  skip: 0,
  pageSize: 30,
  total: null,
  totalAvailable: null,
  totalFetching: false,
  totalLoaded: false,
  search: '',
  transactionType: '',
  sort: DEFAULT_LISTINGS_SORTING,
}
